import dayjs, { Dayjs } from 'dayjs';

export const getOnlyDayByDate = (date: Dayjs | null): Dayjs | null => {
  return date ? dayjs(date).startOf('day') : null;
};
